
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { getToken, IsModemAccess } from '../../../helpers/Helper';
import { del, post } from '../../../helpers/api_helper';
import { POST_ROLE_LIST, DELETE_USER_ROLE, POST_UPDATE_ROLE_STATUS } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";


const UserRoles = (props) => {
    const navigate = useNavigate();
    const [roleId, SetRoleId] = useState(0);


    useMounted(() => {
        get_user_role()
    })

    const get_user_role = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [2, 3] },
                    { "targets": 0, "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    $.ajax({
                        "url": POST_ROLE_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "roleId" },
                    { "data": "roleName" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <button onClick={UpdateStatus.bind(this, data.roleId, data.roleStatus)} className={`border-0 badge ${(data.roleStatus === 'Active') ? 'bg-success' : 'bg-danger'}`}>{data.roleStatus}</button>
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {(IsModemAccess('use_role', 'edit') && data.roleId > 1) && <> <button className="btn btn-sm text-primary mr-2" onClick={() => { navigate('/admin/user-roles/edit/' + data.roleId); }} ><i className="bx bx-edit"></i></button> </>}
                                {(IsModemAccess('use_role', 'delete') && data.roleId > 2) && <button className="btn btn-sm text-danger" onClick={() => { SetRoleId(data.roleId); }} data-bs-toggle="modal" data-bs-target="#deleteModal" ><i className="bx bx-trash-alt align-middle"></i></button>}
                            </>)
                        }
                    },
                ]
            });
        }
    }

    //UpdateStatus
    const UpdateStatus = async (roleId, status) => {
        if (!IsModemAccess('use_role', 'edit')) {
            toast.error('Does not permission this module');
            return;
        }
        var res_data = await post(POST_UPDATE_ROLE_STATUS, { roleId: roleId, status: status });
        if (res_data.status) {
            toast(res_data.message);
            get_user_role();
        } else {
            toast.error(res_data.message);
        }
    }

    // remove user role
    const remove_row = async () => {
        var res_data = await del(DELETE_USER_ROLE + "?roleId=" + roleId);
        if (res_data.status) {
            toast(res_data.message);
            get_user_role();
        } else {
            toast.error(res_data.message);
        }
    }

    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-7 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>User Roles</h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                    {IsModemAccess('use_role', 'add') && <Link to='/admin/user-roles/add' className='btn btn-sm btn-primary'>+ Add</Link>}
                                </div>
                            </div>
                            <hr />
                            <div className='table-responsive text-nowrap'>
                                {IsModemAccess('use_role', 'view') &&
                                    <table id="dataTableExample" className="table table-striped">
                                        <thead>
                                            <tr>
                                                <td>Id</td>
                                                <td>Name</td>
                                                <td>Status</td>
                                                <td>Action</td>
                                            </tr>
                                        </thead>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm Delete</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this record?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button onClick={remove_row.bind(this)} data-bs-dismiss="modal" className="btn btn-primary">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserRoles;